import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import PageRoutes from './components/layout/Routes.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PageRoutes />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// console.log("hello jogen");

// document.addEventListener("DOMContentLoaded", function () {
//  const sections = document.querySelectorAll(".section");
// const menuLinks = document.querySelectorAll(".menu-link");

// const observer = new IntersectionObserver(
//   (entries) => {
//     entries.forEach(entry => {

//       if (entry.isIntersecting) {

//         const id = entry.target.getAttribute("id");

//         menuLinks.forEach(link => {
//           link.classList.remove("active");

//           if (link.getAttribute("href") === "#" + id) {
//             link.classList.add("active");
//           }
//         });

//       }

//     });
//   },
//   {
//     root: null,
//     threshold: 0.5 // 🔥 50% of section visible (middle effect)
//   }
// );

// sections.forEach(section => {
//   observer.observe(section);
// });

// });

document.addEventListener("click", function (e) {

  const clickedLink = e.target.closest(".menu-link");

  if (!clickedLink) return;

  const allLinks = document.querySelectorAll(".menu-link");

  // Remove active from all
  allLinks.forEach(link => link.classList.remove("active"));

  // Add active to clicked
  clickedLink.classList.add("active");

});


document.addEventListener("DOMContentLoaded", function () {

  // Select all sections with an id
  const sections = document.querySelectorAll("section[id]");
  // Select all menu links
  const menuLinks = document.querySelectorAll(".menu-link");

  // If no sections or menu links found, stop
  if (sections.length === 0 || menuLinks.length === 0) return;

  function activateMenuOnScroll() {
    // middle of viewport
    const scrollMiddle = window.scrollY + window.innerHeight / 2;

    let currentSectionId = null;

    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;

      // If the middle of the screen is inside this section
      if (scrollMiddle >= sectionTop && scrollMiddle < sectionBottom) {
        currentSectionId = section.getAttribute("id");
      }
    });

    if (!currentSectionId) return;

    menuLinks.forEach(link => {
      link.classList.remove("active");
      if (link.getAttribute("href") === "#" + currentSectionId) {
        link.classList.add("active");
      }
    });
  }

  // Listen to scroll event
  window.addEventListener("scroll", activateMenuOnScroll);

  // Run once on page load
  activateMenuOnScroll();

});




